import { Component, Input } from '@angular/core';
import { Config } from '../../universal-config';
import { NoteImageViewerService } from './noteImageViewer/NoteImageViewer.service';

@Component({
  selector: 'nns-attachments-list-item',
  styles: [
    `
    :host {
      width:136px;
      margin:0 16px 10px 0;
    }
    .nns-attach-link {
      margin:0 0 4px 0;
      position:relative;
    }
    .nns-attach-link a {
      background:#EBEFF1;
      border:1px solid #DCE1E3;
      box-shadow:0px 1px 3px 0px rgba(0,0,0,0.20);
      border-radius:2px;
      height:76px;
    }
    .nns-attach-link a:hover {background:#fff;}

    .nns-attach-name {font-size:12px;}
    .nns-attach-title-text {
      overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    .nns-attach-download {margin:0 0 0 8px; display:none;}
    .nns-attach-default-view:hover .nns-attach-download {display:block;}
    .nns-attach-size {
      font-size:12px;
      color:#9DA5A6;
    }

    .nns-attach-line-view {display:none;}
    .nns-attach-line-button {
      display:block;
      width:100%;
      background:none;
      border:none;
      cursor:pointer;
      box-sizing:border-box;
      color:#3E4849;
      font-size:14px;
    }
    .nns-attach-line-title {
      margin:0 10px;
    }
    .nns-attach-line-title-text {
      overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    .nns-attach-line-size-text {color:#9DA5A6;}

    @media only screen and (max-width: 768px) {

      :host {width:102px;}
      .nns-attach-link a {height:56px;}
      .nns-attach-download {display:none !important;}

    }

    @media only screen and (max-width: 600px) {

      :host {
        width:100%;
        padding:8px 0;
        border-bottom:1px solid #dcdcdc;
        margin:0;
      }
      nns-attach:last-of-type {border-bottom:none;}
      .nns-attach-default-view {display:none;}
      .nns-attach-line-view {display:block;}

    }
  `, `
    :host-context(.nns-theme-night) .nns-attach-link a {
      background: #292E32;
      box-shadow:0 1px 3px 0 rgba(0,0,0,0.20);
      border-color:#2F3737;
    }
    :host-context(.nns-theme-night) .nns-attach-link a:hover {
      background:rgba(181,181,181,0.10);
    }
    :host-context(.nns-theme-night) {
      border-color:rgba(0,0,0,0.12);
    }
    :host-context(.nns-theme-night) .nns-attach-line-button,
    :host-context(.nns-theme-night) .nns-attach-line-size-text {
      color:#fff;
    }
  `],
  template: `
    <div class="nns-attach-default-view">
    <div class="nns-attach-link">
      <a class="nns-animated"
        *ngIf="attachment.type != 'image' && extension != 'pdf'"
        [routerLink]="[getAttachmentURL(attachment)]"
        flex
        layout="row"
        layout-align="center center"
        title="Show {{attachment.displayName}}">
        <nns-icon [icon]="getIcon(attachment)"
                  *ngIf="getIcon(attachment)"></nns-icon>
      </a>
      <a class="nns-animated"
        *ngIf="extension == 'pdf'"
        flex
        layout="row"
        layout-align="center center"
        title="Show {{attachment.displayName}}"
        (click)="openPdf()">
        <nns-icon [icon]="getIcon(attachment)"
                  *ngIf="getIcon(attachment)"></nns-icon>
      </a>
      <a class="nns-animated"
        *ngIf="attachment.type == 'image'"
        flex
        layout="row"
        layout-align="center center"
        title="Show {{attachment.displayName}}"
        (click)="openImage()">
        <nns-icon [icon]="getIcon(attachment)"
                  *ngIf="getIcon(attachment)"></nns-icon>
      </a>
    </div>
    <div class="nns-attach-name">
      <div class="nns-attach-name-layout"
          flex
          layout="row"
          layout-align="space-between center">
        <div class="nns-attach-title"
            flex="auto"
            layout="row"
            [title]="attachment.displayName"
            layout-align="start center">
          <div class="nns-attach-title-text"
              flex="nogrow">{{nameWithoutExtension}}</div>
          <div class="nns-attach-title-ext" flex="none" *ngIf="extension">.{{extension}}</div>
        </div>
        <div class="nns-attach-download"
            flex="none">
          <a [href]="fileServerUrl + attachment.attachmentURL + '?dw'"
            title="Download {{attachment.displayName}}"
            target="_blank">Download</a>
        </div>
      </div>
    </div>
    <div class="nns-attach-size">{{attachment.humanFileSize}}</div>
  </div>

  <div class="nns-attach-line-view">
    <a [routerLink]="[getAttachmentURL(attachment)]"
      [title]="attachment.displayName"
      class="nns-attach-line-button">
      <span class="nns-attach-line-layout"
            flex
            layout="row"
            layout-align="start center">
          <nns-icon *ngIf="getIcon(attachment)" [icon]="getIcon(attachment)" flex="none"></nns-icon>
      <span class="nns-attach-line-title" flex="auto" layout="row" layout-align="start center">
        <span class="nns-attach-line-title-text">{{nameWithoutExtension}}</span>
        <span class="nns-attach-line-title-ext" *ngIf="extension">.{{extension}}</span>
      </span>
      <span class="nns-attach-line-size"
            flex="none"
            layout="row"
            layout-align="start center">
            <span class="nns-attach-line-size-text">{{attachment.humanFileSize}}</span>
      <nns-icon icon="next-inv"></nns-icon>
      </span>
      </span>
    </a>
  </div>
  `
})
export class AttachmentsListItemComponent {
  @Input() public attachment;
  @Input() public attachmentBases;
  extension;
  nameWithoutExtension;
  fileServerUrl: string;

  constructor(
    private config: Config,
    private noteImageViewerService: NoteImageViewerService,
  ) {
    this.fileServerUrl = this.config.get('BOX_URL')
  }

  ngOnInit() {
    this.extension = this.getExtension();
    this.nameWithoutExtension = this.getNameWithoutExtension();
  }

  ngOnChanges() {
    this.extension = this.getExtension();
    this.nameWithoutExtension = this.getNameWithoutExtension();
  }

  getIcon(attachment) {
    if (!attachment || !attachment.type) {
      return undefined;
    }

    const icons = {
      doc: 'document',
      audio: 'audio',
      video: 'video',
      archive: 'archive',
      image: 'image',
      file: 'other'
    };

    return 'attach-' + (icons[attachment.type] ? icons[attachment.type] : 'other');
  }

  getNameWithoutExtension() {
    if (!this.attachment || !this.attachment.displayName) {
      return undefined;
    } else if (!this.extension) {
      return this.attachment.displayName;
    }

    const extensionLength = this.extension.length;
    const nameLength = this.attachment.displayName.length;

    const nameWithoutExtension = this.attachment.displayName.substr(0, nameLength - extensionLength - 1);

    return nameWithoutExtension;
  }

  getExtension() {
    if (!this.attachment || !this.attachment.displayName) {
      return undefined;
    }

    const displayName = this.attachment.displayName;
    const reduceName = displayName.split('.');
    let extension = "";

    if (reduceName.length > 1) {
      extension = displayName.split('.').pop();
    }

    return extension;
  }

  getAttachmentURL(attachment) {
    if (attachment.type === 'video'
      && (attachment.mime === 'video/mp4' || attachment.mime === 'video/webm' || attachment.mime === 'video/ogg')
    ) {
      return attachment.videoURL;
    }

    if (attachment.type === 'audio') {
      return attachment.audioURL;
    }

    if (attachment.type === 'image') {
      return attachment.imageURL;
    }

    return attachment.attachmentURL;
  }

  openPdf() {
    window.open(`${this.fileServerUrl}${this.attachment.attachmentURL}`, '_blank')
  }

  openImage() {
    const imageUrl = `${this.attachment.attachmentURL}`;
    if (this.noteImageViewerService.setImage(imageUrl)) {
      return this.noteImageViewerService.showImage()
    }
  }
}
